import { render } from "./ModalDistributionDetail.vue?vue&type=template&id=5ade1a6a&scoped=true"
import script from "./ModalDistributionDetail.vue?vue&type=script&lang=js"
export * from "./ModalDistributionDetail.vue?vue&type=script&lang=js"

import "./ModalDistributionDetail.vue?vue&type=style&index=0&id=5ade1a6a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ade1a6a"]])

export default __exports__